import { getRequest } from '../services/requestHandler';
import { HeadTypeFamily } from '../models';

//3 for testing
export const getHeadTypeFamilies = async () => {
  //  const url = `head/getHeadTypeFamilies?headTypeIds=${headTypeId}`;
  const url = `head/getHeadTypeFamilies`;
  const response = await getRequest<HeadTypeFamily>('GetHeadTypeFamilies', url);
  return response;
};
